let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("jvPYJ")).then(() => parcelRequire('2sfBf'));